import { render, staticRenderFns } from "./ExpensesDetailTable.vue?vue&type=template&id=fb197e78&"
import script from "./ExpensesDetailTable.vue?vue&type=script&lang=ts&"
export * from "./ExpensesDetailTable.vue?vue&type=script&lang=ts&"
import style0 from "./ExpensesDetailTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports